import { render } from "./App.vue?vue&type=template&id=3df46240"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3df46240&lang=scss"

import exportComponent from "/Users/funguy/code/integrity-planet/webview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__